// extracted by mini-css-extract-plugin
export var banner = "_iy-0";
export var closeButton = "_iy-2";
export var greenCheckmark = "_iy-3";
export var hereLink = "_iy-4";
export var titleIcon = "_iy-1";